import request from 'utils/header'

const postPalscon = async (path, data) => {
  const response = await request.post(path, data)
  const payload = response?.data || {}

  if (!response?.ok || payload?.success === false) {
    const error = new Error(payload?.msg || 'The request could not be completed. Please try again.')
    error.status = response?.status
    error.retryAfterSeconds = payload?.retryAfterSeconds
    throw error
  }

  return payload
}

const parsePalsconResponse = (response, fallbackMessage) => {
  const payload = response?.data || {}
  if (!response?.ok || payload?.success === false) {
    const error = new Error(payload?.msg || fallbackMessage)
    error.status = response?.status
    throw error
  }
  return payload
}

const resolvePalsconLoginMethod = (identifier, loginMethod) => (
  String(identifier || '').includes('@') ? 'email' : (loginMethod === 'phone' ? 'phone' : 'email')
)

const verifyPalsconEmail = (identifier, loginMethod = 'email') => {
  const method = resolvePalsconLoginMethod(identifier, loginMethod)
  return postPalscon(
    method === 'phone' ? '/palscon/verify-phone' : '/palscon/verify-email',
    method === 'phone' ? {phone: identifier, loginMethod: method} : {email: identifier, loginMethod: method},
  )
}

const verifyPalsconOtp = (identifier, otp, loginMethod = 'email') => {
  const method = resolvePalsconLoginMethod(identifier, loginMethod)
  return postPalscon('/palscon/verify-otp', method === 'phone' ? {phone: identifier, otp} : {email: identifier, otp})
}

const loginRegisteredPalsconUser = (identifier, loginMethod = 'phone') => postPalscon(
  '/palscon/login',
  loginMethod === 'phone' ? {phone: identifier, loginMethod} : {email: identifier, loginMethod},
)

const registerPalsconAttendee = (registration) => postPalscon('/palscon/register', registration)

const getPalsconDashboardContexts = async () => {
  const response = await request.get('/palscon/dashboard-contexts')
  const payload = response?.data || {}

  if (!response?.ok || payload?.success === false) {
    const error = new Error(payload?.msg || 'Dashboard options could not be loaded. Please try again.')
    error.status = response?.status
    throw error
  }

  return payload.data
}

const getPalsconTimeLogsStatus = async (type = 'industry', view = 'active') => {
  const query = new URLSearchParams({type, view})
  const response = await request.get(`/palscon/time_log_status?${query.toString()}`)
  return parsePalsconResponse(response, 'The participant list could not be loaded. Please try again.')
}

const updatePalsconParticipantPayment = async (participantId, isPaid, note = '') => {
  const response = await request.patch(`/palscon/participants/${participantId}/payment`, {isPaid, note})
  return parsePalsconResponse(response, 'The payment status could not be updated.')
}

const userInterested = (email) => postPalscon('/palscon/user-interested', {email})

const updatePalsconParticipantArchive = async (participantId, isArchived, note = '') => {
  const response = await request.patch(`/palscon/participants/${participantId}/archive`, {isArchived, note})
  return parsePalsconResponse(response, 'The archive status could not be updated.')
}

const getPalsconParticipantAudit = async (filters = {}) => {
  const query = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value)
  })
  const response = await request.get(`/palscon/participant-audit?${query.toString()}`)
  return parsePalsconResponse(response, 'Audit history could not be loaded.')
}

export {
  getPalsconDashboardContexts,
  getPalsconParticipantAudit,
  getPalsconTimeLogsStatus,
  loginRegisteredPalsconUser,
  registerPalsconAttendee,
  updatePalsconParticipantArchive,
  updatePalsconParticipantPayment,
  verifyPalsconEmail,
  verifyPalsconOtp,
  userInterested
}
